import React, { useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import WhatsAppPreview from './WhatsAppPreview';
import NodeEditModal from './NodeEditModal';
import TextMessageModal from './TextMessageModal';
import TextButtonsModal from './TextButtonsModal';
import StartBotModal from './StartBotModal';
import ImageModal from './ImageModal';
import VideoModal from './VideoModal';
import AudioModal from './AudioModal';
import FileModal from './FileModal';
import InteractiveModal from './InteractiveModal';
import CTAModal from './CTAModal';
import NextModal from './NextModal';
import EcommerceModal from './EcommerceModal';
import ButtonsModal from './ButtonsModal';
import ListMessagesModal from './ListMessagesModal';
import HttpApiModal from './HttpApiModal';
import ConditionModal from './ConditionModal';
import LocationModal from './LocationModal';
import domain from '../../../../reusecomponent/domain';
import { getToken } from '../../../function/token';

// Use the provided logo as the profile image
const profileImg = 'https://oaidalleapiprodscus.blob.core.windows.net/private/org-3bQkQw8QkQkQkQkQkQkQkQkQ/user-3bQkQw8QkQkQkQkQkQkQkQkQ/img-3bQkQw8QkQkQkQkQkQkQkQkQ.png';

function isFirstNode(id, edges) {
  return !edges.some(e => e.target === id);
}

function hasOutgoingEdge(id, edges) {
  return edges.some(e => e.source === id);
}



export default function CustomNode({ data, id }) {
  const [showPreview, setShowPreview] = useState(false);
  const [showNodeEditModal, setShowNodeEditModal] = useState(false);
  const [showTextMessageModal, setShowTextMessageModal] = useState(false);
  const [showTextButtonsModal, setShowTextButtonsModal] = useState(false);
  const [showStartBotModal, setShowStartBotModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showAudioModal, setShowAudioModal] = useState(false);
  const [showFileModal, setShowFileModal] = useState(false);
  const [showInteractiveModal, setShowInteractiveModal] = useState(false);
  const [showCTAModal, setShowCTAModal] = useState(false);
  const [showNextModal, setShowNextModal] = useState(false);
  const [showEcommerceModal, setShowEcommerceModal] = useState(false);
  const [showButtonsModal, setShowButtonsModal] = useState(false);
  const [showListMessagesModal, setShowListMessagesModal] = useState(false);
  const [showHttpApiModal, setShowHttpApiModal] = useState(false);
  const [showConditionModal, setShowConditionModal] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [hovered, setHovered] = useState(false);

  // Clean and clear node styles
  const cardStyle = {
    background: '#ffffff',
    borderRadius: 6,
    minWidth: 280,
    maxWidth: 320,
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    position: 'relative',
    margin: 0,
    padding: 0,
    overflow: 'visible',
    border: data.type === 'start' ? '2px solid #28a745' : '1px solid #e1e5e9',
    transition: 'all 0.2s ease',
    cursor: 'pointer',
  };
  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    background: data.type === 'start' ? '#d4edda' : '#f8f9fa',
    color: data.type === 'start' ? '#155724' : '#495057',
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    padding: '10px 12px',
    fontWeight: 500,
    fontSize: 14,
    justifyContent: 'space-between',
    borderBottom: '1px solid #dee2e6',
    position: 'relative',
    zIndex: 2,
  };
  const logoStyle = {
    width: 20,
    height: 20,
    borderRadius: '3px',
    marginRight: 8,
    background: '#6c757d',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    color: '#ffffff',
    fontSize: 12,
  };
  const closeBtnStyle = {
    background: '#dc3545',
    color: '#ffffff',
    border: 'none',
    borderRadius: '3px',
    width: 18,
    height: 18,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    transition: 'background 0.2s ease',
    position: 'relative',
    zIndex: 3,
  };
  const contentStyle = {
    background: '#ffffff',
    padding: '12px',
    minHeight: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#6c757d',
    fontSize: 13,
    overflow: 'visible',
  };
  const actionBtnStyle = {
    position: 'absolute',
    top: 6,
    right: 6,
    display: 'flex',
    gap: 4,
    zIndex: 1,
  };
  const smallBtnStyle = {
    background: '#ffffff',
    border: '1px solid #ced4da',
    borderRadius: '3px',
    width: 22,
    height: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    fontSize: 11,
    color: '#495057',
    transition: 'background 0.2s ease, color 0.2s ease',
  };

  return (
    <>
      <div
        style={cardStyle}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        title="Node"
      >
        <Handle 
          type="target" 
          position={Position.Left}
          style={{
            background: '#6c757d',
            border: '2px solid #ffffff',
            width: 14,
            height: 14,
            borderRadius: '50%',
            boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
            cursor: 'crosshair',
            zIndex: 10000,
            left: -7,
            top: '50%',
            transform: 'translateY(-50%)'
          }} 
        />
        {/* Hover action buttons */}
        {hovered && (
          <div style={actionBtnStyle}>
            <div
              style={smallBtnStyle}
              title="Copy Node"
              onClick={e => { e.stopPropagation(); data.onCopy && data.onCopy(id); }}
            >
              📄
            </div>
            <div
              style={{ ...smallBtnStyle, color: '#28a745' }}
              title="Preview Message"
              onClick={e => { e.stopPropagation(); setShowPreview(true); }}
            >
              👁️
            </div>
          </div>
        )}
        {/* Header */}
        <div style={headerStyle}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={logoStyle}>
              {data.type === 'start' ? '🚀' : 
               data.type === 'message' ? '💬' : 
               data.type === 'text_button' ? '📝' :
               data.type === 'text_buttons' ? '💬🔘' :
               data.type === 'media' ? '🖼️' :
               data.type === 'video' ? '🎥' :
               data.type === 'audio' ? '🎵' :
               data.type === 'file' ? '📄' :
               data.type === 'interactive' ? '💬' :
               data.type === 'cta_url' ? '🔗' :
               data.type === 'location' ? '📍' :
               data.type === 'condition' ? '❓' : 
               data.type === 'http_api' ? '🔌' : 
               data.type === 'google_sheet' ? '📊' :
               data.type === 'whatsapp_flows' ? '📱' :
               data.type === 'user_input' ? '👤' :
               data.type === 'ai_reply' ? '🤖' :
               '📝'}
            </div>
            <span>{data.type === 'start' ? 'Start Bot' : 
                   data.type === 'message' ? 'Message' : 
                   data.type === 'text_button' ? 'Text' :
                   data.type === 'text_buttons' ? 'Text + Buttons' :
                   data.type === 'media' ? 'Image' :
                   data.type === 'video' ? 'Video' :
                   data.type === 'audio' ? 'Audio' :
                   data.type === 'file' ? 'File' :
                   data.type === 'interactive' ? 'Interactive' :
                   data.type === 'cta_url' ? 'CTA URL' :
                   data.type === 'location' ? 'Location' :
                   data.type === 'condition' ? 'Condition' : 
                   data.type === 'http_api' ? 'HTTP API' : 
                   data.type === 'google_sheet' ? 'Google Sheet' :
                   data.type === 'whatsapp_flows' ? 'WhatsApp Flows' :
                   data.type === 'user_input' ? 'User Input' :
                   data.type === 'ai_reply' ? 'AI Reply' :
                   'Action'}</span>
          </div>
          <button
            onClick={e => { 
              e.stopPropagation(); 
              // Prevent deletion of start nodes
              if (data.type === 'start') {
                alert('Start Bot nodes cannot be deleted. They are required for the chatbot to function.');
                return;
              }
              data.onDelete(id); 
            }}
            style={{
              ...closeBtnStyle,
              // Hide delete button for start nodes
              display: data.type === 'start' ? 'none' : 'flex'
            }}
            onMouseOver={e => e.currentTarget.style.background = '#c82333'}
            onMouseOut={e => e.currentTarget.style.background = '#dc3545'}
            title={data.type === 'start' ? 'Start nodes cannot be deleted' : 'Delete node'}
          >
            ×
          </button>
        </div>
        {/* Content */}
        <div 
          style={contentStyle}
                                  onDoubleClick={() => {
                          if (data.type === 'start') {
                            setShowStartBotModal(true);
                          } else if (data.type === 'text_button' || data.type === 'message') {
                            setShowTextMessageModal(true);
                          } else if (data.type === 'text_buttons') {
                            setShowTextButtonsModal(true);
                          } else if (data.type === 'media') {
                            setShowImageModal(true);
                          } else if (data.type === 'video') {
                            setShowVideoModal(true);
                          } else if (data.type === 'audio') {
                            setShowAudioModal(true);
                          } else if (data.type === 'file') {
                            setShowFileModal(true);
                          } else if (data.type === 'interactive') {
                            setShowInteractiveModal(true);
                          } else if (data.type === 'cta_url') {
                            setShowCTAModal(true);
                          } else if (data.type === 'next') {
                            setShowNextModal(true);
                          } else if (data.type === 'ecommerce') {
                            setShowEcommerceModal(true);
                          } else if (data.type === 'buttons') {
                            setShowButtonsModal(true);
                          } else if (data.type === 'list_messages') {
                            setShowListMessagesModal(true);
                          } else if (data.type === 'http_api') {
                            setShowHttpApiModal(true);
                          } else if (data.type === 'condition') {
                            setShowConditionModal(true);
                          } else if (data.type === 'location') {
                            setShowLocationModal(true);
                          } else {
                            setShowNodeEditModal(true);
                          }
                        }}
        >
          {data.type === 'start' ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              {data.keywords && data.keywords.length > 0 ? (
                <>
                  <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                    {data.title || 'Start Bot Flow'}
                  </div>
                  <div style={{ fontSize: 11, color: '#6c757d', marginBottom: 2 }}>
                    Keywords: {data.keywords.join(', ')}
                  </div>
                  <div style={{ fontSize: 11, color: '#6c757d' }}>
                    Match: {data.matchingType === 'exact' ? 'Exact' : 'Contains'}
                  </div>
                </>
              ) : (
                <div style={{ textAlign: 'center', color: '#adb5bd', fontStyle: 'italic' }}>
                  Double-click to configure
                </div>
              )}
            </div>
          ) : data.type === 'http_api' ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              {data.selectedApi ? (
                <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                  {data.selectedApi}
                </div>
              ) : (
                <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                  {data.apiName || 'HTTP API'}
                </div>
              )}
              <div style={{ fontSize: 11, color: '#6c757d' }}>
                {data.method || 'POST'} • {data.url ? (data.url.length > 30 ? data.url.substring(0, 30) + '...' : data.url) : 'No URL'}
              </div>
            </div>
          ) : data.type === 'condition' ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                {data.matchType === 'all' ? 'All Match' : 'Any Match'}
              </div>
              <div style={{ fontSize: 11, color: '#6c757d' }}>
                {data.systemConditions?.length || 0} system • {data.customConditions?.length || 0} custom
              </div>
            </div>
          ) : data.type === 'location' ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                {data.bodyText ? (data.bodyText.length > 30 ? data.bodyText.substring(0, 30) + '...' : data.bodyText) : 'Location Template'}
              </div>
              <div style={{ fontSize: 11, color: '#6c757d' }}>
                📍 Location • {data.delay || 0}s delay
              </div>
            </div>
          ) : data.type === 'video' ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              {data.videoUrl || data.customField || data.sendMethod ? (
                <>
                  <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                    {data.sendMethod === 'custom' ? 
                      `Custom: ${data.customField || 'Select field'}` : 
                      data.videoUrl ? 
                        (data.videoUrl.length > 30 ? data.videoUrl.substring(0, 30) + '...' : data.videoUrl) :
                        'Upload Video'
                    }
                  </div>
                  <div style={{ fontSize: 11, color: '#6c757d' }}>
                    🎥 Video • {data.sendMethod === 'upload' ? 'Upload' : 'Custom Field'}
                  </div>
                  {data.delay > 0 && (
                    <div style={{ fontSize: 11, color: '#6c757d' }}>
                      {data.delay}s delay
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: 'center', color: '#adb5bd', fontStyle: 'italic' }}>
                  Double-click to configure
                </div>
              )}
            </div>
          ) : data.type === 'text_button' || data.type === 'message' ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              {data.message ? (
                <>
                  <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                    {data.message.length > 50 ? data.message.substring(0, 50) + '...' : data.message}
                  </div>
                  {data.delay > 0 && (
                    <div style={{ fontSize: 11, color: '#6c757d' }}>
                      {data.delay}s delay
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: 'center', color: '#adb5bd', fontStyle: 'italic' }}>
                  Double-click to configure
                </div>
              )}
            </div>
          ) : data.type === 'text_buttons' ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              {data.message ? (
                <>
                  <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                    {data.message.length > 50 ? data.message.substring(0, 50) + '...' : data.message}
                  </div>
                  {data.buttons && data.buttons.length > 0 && (
                    <div style={{ marginBottom: 4, paddingRight: 10 }}>
                      {data.buttons.map((button, index) => (
                        <div key={index} style={{
                          display: 'block',
                          background: '#128C7E',
                          color: 'white',
                          padding: '6px 12px',
                          borderRadius: 6,
                          fontSize: 11,
                          margin: '3px 0',
                          fontWeight: 500,
                          position: 'relative',
                          marginRight: 8,
                          textAlign: 'center',
                          minWidth: '80px'
                        }}>
                          {button.label || `Button ${index + 1}`}
                          <Handle
                            type="source"
                            position={Position.Right}
                            id={`button-${index}`}
                            style={{
                              background: '#128C7E',
                              border: '2px solid #ffffff',
                              width: 14,
                              height: 14,
                              right: -7,
                              top: '50%',
                              transform: 'translateY(-50%)',
                              boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
                              cursor: 'crosshair',
                              zIndex: 10000
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                  <div style={{ fontSize: 11, color: '#6c757d' }}>
                    {data.buttons?.length || 0} button{data.buttons?.length !== 1 ? 's' : ''}
                  </div>
                  {data.delay > 0 && (
                    <div style={{ fontSize: 11, color: '#6c757d' }}>
                      {data.delay}s delay
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: 'center', color: '#adb5bd', fontStyle: 'italic' }}>
                  Double-click to configure
                </div>
              )}
            </div>
          ) : data.type === 'buttons' ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              {data.message ? (
                <>
                  <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                    {data.message.length > 50 ? data.message.substring(0, 50) + '...' : data.message}
                  </div>
                  <div style={{ fontSize: 11, color: '#6c757d' }}>
                    {data.buttons?.length || 0} button{data.buttons?.length !== 1 ? 's' : ''} • Max: {data.maxButtons || 3}
                  </div>
                  {data.delay > 0 && (
                    <div style={{ fontSize: 11, color: '#6c757d' }}>
                      {data.delay}s delay
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: 'center', color: '#adb5bd', fontStyle: 'italic' }}>
                  Double-click to configure
                </div>
              )}
            </div>
          ) : data.type === 'cta_url' ? (
            <div style={{ width: '100%', padding: '8px 0' }}>
              {/* Header Field */}
              {data.headerMessage && (
                <div style={{ 
                  marginBottom: 6,
                  padding: '4px 8px',
                  background: '#f8f9fa',
                  borderRadius: 4,
                  fontSize: 11,
                  color: '#495057',
                  borderLeft: '3px solid #007bff'
                }}>
                  <strong>Header:</strong> {data.headerMessage.length > 30 ? data.headerMessage.substring(0, 30) + '...' : data.headerMessage}
                </div>
              )}
              
              {/* Body Field */}
              {data.bodyMessage && (
                <div style={{ 
                  marginBottom: 6,
                  padding: '4px 8px',
                  background: '#f8f9fa',
                  borderRadius: 4,
                  fontSize: 11,
                  color: '#495057',
                  borderLeft: '3px solid #28a745'
                }}>
                  <strong>Body:</strong> {data.bodyMessage.length > 40 ? data.bodyMessage.substring(0, 40) + '...' : data.bodyMessage}
                </div>
              )}
              
              {/* Footer Field */}
              {data.footerMessage && (
                <div style={{ 
                  marginBottom: 6,
                  padding: '4px 8px',
                  background: '#f8f9fa',
                  borderRadius: 4,
                  fontSize: 11,
                  color: '#495057',
                  borderLeft: '3px solid #ffc107'
                }}>
                  <strong>Footer:</strong> {data.footerMessage.length > 40 ? data.footerMessage.substring(0, 40) + '...' : data.footerMessage}
                </div>
              )}
              
              {/* Button */}
              {data.buttonText && (
                <div style={{ 
                  marginBottom: 6,
                  textAlign: 'center'
                }}>
                  <div style={{ 
                    background: '#000000', 
                    color: '#ffffff', 
                    padding: '6px 12px', 
                    borderRadius: 6,
                    fontSize: 11,
                    display: 'inline-block',
                    fontWeight: 500
                  }}>
                    {data.buttonText}
                  </div>
                </div>
              )}
              
              {/* Delay Setting */}
              {data.delay > 0 && (
                <div style={{ 
                  fontSize: 10, 
                  color: '#6c757d', 
                  textAlign: 'center',
                  marginTop: 4
                }}>
                  Delay: {data.delay}s
                </div>
              )}
              
              {/* Empty State */}
              {!data.headerMessage && !data.bodyMessage && !data.footerMessage && !data.buttonText && (
                <div style={{ textAlign: 'center', color: '#adb5bd', fontStyle: 'italic', fontSize: 11 }}>
                  Double-click to configure
                </div>
              )}
            </div>
          ) : data.type === 'list_messages' ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              {data.title ? (
                <>
                  <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                    {data.title}
                  </div>
                  <div style={{ fontSize: 11, color: '#6c757d' }}>
                    {data.items?.length || 0} item{data.items?.length !== 1 ? 's' : ''} • {data.buttonText || 'View Options'}
                  </div>
                  {data.delay > 0 && (
                    <div style={{ fontSize: 11, color: '#6c757d' }}>
                      {data.delay}s delay
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: 'center', color: '#adb5bd', fontStyle: 'italic' }}>
                  Double-click to configure
                </div>
              )}
            </div>
          ) : data.type === 'ecommerce' ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              {data.catalogType ? (
                <>
                  <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                    {data.catalogType.charAt(0).toUpperCase() + data.catalogType.slice(1)} Catalog
                  </div>
                  <div style={{ fontSize: 11, color: '#6c757d' }}>
                    Max: {data.maxItems || 10} items • {data.showPrice ? 'Price' : 'No Price'} • {data.showDescription ? 'Desc' : 'No Desc'}
                  </div>
                  {data.delay > 0 && (
                    <div style={{ fontSize: 11, color: '#6c757d' }}>
                      {data.delay}s delay
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: 'center', color: '#adb5bd', fontStyle: 'italic' }}>
                  Double-click to configure
                </div>
              )}
            </div>
          ) : data.type === 'next' ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              {data.nextAction ? (
                <>
                  <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                    {data.nextAction === 'continue' ? 'Continue Flow' : data.nextAction === 'redirect' ? 'Redirect' : 'End Flow'}
                  </div>
                  {data.targetNode && (
                    <div style={{ fontSize: 11, color: '#6c757d' }}>
                      Target: {data.targetNode}
                    </div>
                  )}
                  {data.delay > 0 && (
                    <div style={{ fontSize: 11, color: '#6c757d' }}>
                      {data.delay}s delay
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: 'center', color: '#adb5bd', fontStyle: 'italic' }}>
                  Double-click to configure
                </div>
              )}
            </div>
          ) : data.type === 'interactive' ? (
            <div style={{ width: '100%', padding: '8px 0' }}>
              <div style={{ display: 'flex', gap: '12px' }}>
                {/* Left Side - Message Content Area */}
                <div style={{ flex: 1 }}>
                  {/* Header Field */}
                  {data.headerText && (
                    <div style={{ 
                      marginBottom: 6,
                      padding: '4px 8px',
                      background: '#f8f9fa',
                      borderRadius: 4,
                      fontSize: 11,
                      color: '#495057',
                      borderLeft: '3px solid #007bff'
                    }}>
                      <strong>Header:</strong> {data.headerText.length > 25 ? data.headerText.substring(0, 25) + '...' : data.headerText}
                    </div>
                  )}
                  
                  {/* Body Field */}
                  {data.messageBody && (
                    <div style={{ 
                      marginBottom: 6,
                      padding: '4px 8px',
                      background: '#f8f9fa',
                      borderRadius: 4,
                      fontSize: 11,
                      color: '#495057',
                      borderLeft: '3px solid #28a745'
                    }}>
                      <strong>Body:</strong> {data.messageBody.length > 35 ? data.messageBody.substring(0, 35) + '...' : data.messageBody}
                    </div>
                  )}
                  
                  {/* Footer Field */}
                  {data.footerText && (
                    <div style={{ 
                      marginBottom: 6,
                      padding: '4px 8px',
                      background: '#f8f9fa',
                      borderRadius: 4,
                      fontSize: 11,
                      color: '#495057',
                      borderLeft: '3px solid #ffc107'
                    }}>
                      <strong>Footer:</strong> {data.footerText.length > 35 ? data.footerText.substring(0, 35) + '...' : data.footerText}
                    </div>
                  )}
                  
                  {/* Empty State */}
                  {!data.headerText && !data.messageBody && !data.footerText && (
                    <div style={{ textAlign: 'center', color: '#adb5bd', fontStyle: 'italic', fontSize: 11 }}>
                      Double-click to configure
                    </div>
                  )}
                </div>
                
                {/* Right Side - Interactive Options */}
                <div style={{ 
                  width: '90px',
                  fontSize: 11, 
                  color: '#495057',
                  position: 'relative'
                }}>
                  {/* Reply Option with Connection Handle */}
                  
                  
                  {/* Next Option with Connection Handle */}
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between',
                    marginBottom: 8,
                    padding: '4px 6px',
                    cursor: 'pointer',
                    position: 'relative',
                    borderRadius: 4,
                    background: data.interactiveType === 'next' ? '#f8f9fa' : 'transparent',
                    border: data.interactiveType === 'next' ? '1px solid #dee2e6' : '1px solid transparent'
                  }}
                  onClick={() => data.onOptionClick && data.onOptionClick('next')}
                  title="Connect Next node">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      
                      <span style={{ fontWeight: data.interactiveType === 'next' ? '500' : 'normal' }}>Next</span>
                    </div>
                    <Handle
                      type="source"
                      position={Position.Right}
                      id={`${id}-next`}
                      style={{
                        background: '#28a745',
                        border: '2px solid #ffffff',
                        width: 10,
                        height: 10,
                        right: -5,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                      }}
                    />
                  </div>
                  
                  {/* Buttons Option with Connection Handle */}
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between',
                    marginBottom: 8,
                    padding: '4px 6px',
                    cursor: 'pointer',
                    position: 'relative',
                    borderRadius: 4,
                    background: data.interactiveType === 'buttons' ? '#f8f9fa' : 'transparent',
                    border: data.interactiveType === 'buttons' ? '1px solid #dee2e6' : '1px solid transparent'
                  }}
                  onClick={() => data.onOptionClick && data.onOptionClick('buttons')}
                  title="Connect Buttons node">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                     
                      <span style={{ fontWeight: data.interactiveType === 'buttons' ? '500' : 'normal' }}>Buttons</span>
                    </div>
                    <Handle
                      type="source"
                      position={Position.Right}
                      id={`${id}-buttons`}
                      style={{
                        background: '#ffc107',
                        border: '2px solid #ffffff',
                        width: 10,
                        height: 10,
                        right: -5,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                      }}
                    />
                  </div>
                </div>
              </div>
              
              {/* Delay Setting */}
              {data.delay > 0 && (
                <div style={{ 
                  fontSize: 10, 
                  color: '#6c757d', 
                  textAlign: 'center',
                  marginTop: 8,
                  padding: '4px 8px',
                  background: '#f8f9fa',
                  borderRadius: 4
                }}>
                  Delay: {data.delay}s
                </div>
              )}
            </div>
          ) : data.type === 'media' ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              {(data.mediaUrl || data.imageUrl) ? (
                <>
                  <div style={{ marginBottom: 8 }}>
                    {data.mediaType === 'image' && (
                      <img 
                        src={data.mediaUrl || data.imageUrl} 
                        alt="Image preview"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100px',
                          borderRadius: 4,
                          objectFit: 'cover',
                          border: '1px solid #e0e0e0'
                        }}
                      />
                    )}
                    {data.mediaType === 'video' && (
                      <div style={{ position: 'relative', maxHeight: '100px', borderRadius: 4, overflow: 'hidden', border: '1px solid #e0e0e0' }}>
                        <video 
                          src={data.mediaUrl || data.imageUrl}
                          style={{
                            width: '100%',
                            height: '100px',
                            objectFit: 'cover'
                          }}
                          controls={false}
                          preload="metadata"
                        />
                        <div style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          background: 'rgba(0,0,0,0.7)',
                          borderRadius: '50%',
                          width: '40px',
                          height: '40px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer'
                        }} onClick={(e) => {
                          e.stopPropagation();
                          const video = e.target.closest('div').previousSibling;
                          if (video.paused) {
                            video.play();
                          } else {
                            video.pause();
                          }
                        }}>
                          <span style={{ color: 'white', fontSize: '16px' }}>▶️</span>
                        </div>
                      </div>
                    )}
                    {data.mediaType === 'audio' && (
                      <div style={{
                        background: '#f8f9fa',
                        border: '1px solid #e0e0e0',
                        borderRadius: 4,
                        padding: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                      }}>
                        <audio 
                          src={data.mediaUrl || data.imageUrl}
                          style={{ display: 'none' }}
                          preload="metadata"
                        />
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            const audio = e.target.closest('div').querySelector('audio');
                            if (audio.paused) {
                              audio.play();
                              e.target.textContent = '⏸️';
                            } else {
                              audio.pause();
                              e.target.textContent = '▶️';
                            }
                          }}
                          style={{
                            background: '#128C7E',
                            color: 'white',
                            border: 'none',
                            borderRadius: '50%',
                            width: '32px',
                            height: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            fontSize: '14px'
                          }}
                        >
                          ▶️
                        </button>
                        <span style={{ fontSize: '12px', color: '#6c757d' }}>🎵 Audio</span>
                      </div>
                    )}
                    {data.mediaType === 'document' && (
                      <div style={{
                        background: '#f8f9fa',
                        border: '1px solid #e0e0e0',
                        borderRadius: 4,
                        padding: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                      }}>
                        <span style={{ fontSize: '24px' }}>📄</span>
                        <span style={{ fontSize: '12px', color: '#6c757d' }}>Document</span>
                      </div>
                    )}
                  </div>
                  <div style={{ fontSize: 11, color: '#6c757d' }}>
                    {data.mediaType === 'image' && '🖼️ Image'}
                    {data.mediaType === 'video' && '🎥 Video'}
                    {data.mediaType === 'audio' && '🎵 Audio'}
                    {data.mediaType === 'document' && '📄 Document'}
                    {!data.mediaType && '🖼️ Image'} • {data.delay || 0}s delay
                  </div>
                </>
              ) : (
                <div style={{ textAlign: 'center', color: '#adb5bd', fontStyle: 'italic' }}>
                  Double-click to configure
                </div>
              )}
            </div>
          ) : data.message ? (
            <div style={{ textAlign: 'center', width: '100%' }}>
              <div style={{ fontWeight: 500, color: '#495057', marginBottom: 4 }}>
                {data.message.length > 50 ? data.message.substring(0, 50) + '...' : data.message}
              </div>
              {/* Button display removed for all message types - buttons handled by dedicated button nodes */}
            </div>
          ) : (
            <div style={{ textAlign: 'center', color: '#adb5bd', fontStyle: 'italic' }}>
              Double-click to configure
            </div>
          )}
        </div>
        <Handle 
          type="source" 
          position={Position.Right}
          id="main-output"
          style={{
            background: '#6c757d',
            border: '2px solid #ffffff',
            width: 14,
            height: 14,
            borderRadius: '50%',
            boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
            cursor: 'crosshair',
            zIndex: 10000,
            right: -7,
            top: '50%',
            transform: 'translateY(-50%)'
          }} 
        />
      </div>
      {/* Start Bot Modal */}
      <StartBotModal
        open={showStartBotModal}
        onClose={() => setShowStartBotModal(false)}
        node={{ id, data }}
        onSave={(nodeId, formData) => {
          if (data.setNodeData) {
            data.setNodeData(d => ({
              ...d,
              ...formData
            }));
          }
        }}
      />
      
      {/* Text Message Modal */}
      <TextMessageModal
        open={showTextMessageModal}
        onClose={() => setShowTextMessageModal(false)}
        node={{ id, data }}
        onSave={(nodeId, formData) => {
          if (data.setNodeData) {
            data.setNodeData(d => ({
              ...d,
              ...formData
            }));
          }
        }}
      />
      
      {/* Text Buttons Modal */}
      <TextButtonsModal
        open={showTextButtonsModal}
        onClose={() => setShowTextButtonsModal(false)}
        node={{ id, data }}
        onSave={(nodeId, formData) => {
          if (data.setNodeData) {
            data.setNodeData(d => ({
              ...d,
              ...formData
            }));
          }
        }}
      />
      
                  {/* Node Edit Modal */}
            <NodeEditModal
              open={showNodeEditModal}
              onClose={() => setShowNodeEditModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData,
                    selectedTemplate: formData.template
                  }));
                }
              }}
            />
            
            {/* Image Modal */}
            <ImageModal
              open={showImageModal}
              onClose={() => setShowImageModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
            
            {/* Video Modal */}
            <VideoModal
              open={showVideoModal}
              onClose={() => setShowVideoModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
            
            {/* Audio Modal */}
            <AudioModal
              open={showAudioModal}
              onClose={() => setShowAudioModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
            
            {/* File Modal */}
            <FileModal
              open={showFileModal}
              onClose={() => setShowFileModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
            
            {/* Interactive Modal */}
            <InteractiveModal
              open={showInteractiveModal}
              onClose={() => setShowInteractiveModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
            
            {/* CTA Modal */}
            <CTAModal
              open={showCTAModal}
              onClose={() => setShowCTAModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
            
            {/* Next Modal */}
            <NextModal
              open={showNextModal}
              onClose={() => setShowNextModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
            
            {/* Ecommerce Modal */}
            <EcommerceModal
              open={showEcommerceModal}
              onClose={() => setShowEcommerceModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
            
            {/* Buttons Modal */}
            <ButtonsModal
              open={showButtonsModal}
              onClose={() => setShowButtonsModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
            
            {/* List Messages Modal */}
            <ListMessagesModal
              open={showListMessagesModal}
              onClose={() => setShowListMessagesModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
            
            {/* HTTP API Modal */}
            <HttpApiModal
              open={showHttpApiModal}
              onClose={() => setShowHttpApiModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
            
            {/* Condition Modal */}
            <ConditionModal
              open={showConditionModal}
              onClose={() => setShowConditionModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
            
            {/* Location Modal */}
            <LocationModal
              open={showLocationModal}
              onClose={() => setShowLocationModal(false)}
              node={{ id, data }}
              onSave={(nodeId, formData) => {
                if (data.setNodeData) {
                  data.setNodeData(d => ({
                    ...d,
                    ...formData
                  }));
                }
              }}
            />
      
      {/* WhatsApp Preview Modal */}
      <WhatsAppPreview
        node={{ id, data }}
        isVisible={showPreview}
        onClose={() => setShowPreview(false)}
        sidePanel={true}
      />
    </>
  );
} 